import { Component } from '@angular/core';

@Component({
  selector: 'app-print-layout-footer',
  templateUrl: './print-layout-footer.component.html',
  styleUrls: ['./print-layout-footer.component.css']
})
export class PrintLayoutFooterComponent {

}
